import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { columnas } from "./columns";

type Entity = models.PaquetePendienteDto;
export interface Props {
    value: Entity[];
    onQuitar: (x: Entity) => void | Promise<void>;
    readonly?: boolean;
}

class PaquetesListNoRx extends React.PureComponent<Props> {
    onQuitar = async (x: Entity) => {
        if(await kea.yesno("Quitar paquete", `¿Quitar paquete ${x.NumeroFisico} de la guía ${x.FolioGuia}?`)){
            await this.props.onQuitar(x);
        }
    }


    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Paquetes" size="h4" />
                <kea.Grid2 items={this.props.value} columnas={cols} />
            </div>
        );
    }
}
export const PaquetesPendientesList = kea.mapProps(componentToRx(PaquetesListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/componentes/cargas/pendientes/paquetes/list.tsx